import React, { useContext, useEffect } from "react";
import "../css/paysuccess.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";
import { Link, useLocation } from "react-router-dom";
import { CartContext } from "./CartContext";

const PaySuccess = () => {
  const { cartItems, clearCart } = useContext(CartContext);
  const location = useLocation();
  const state = new URLSearchParams(location.search).get("state");
  const isSuccess = state === "success";

  useEffect(() => {
    if (isSuccess && cartItems.length > 0) clearCart();
  }, [cartItems.length, clearCart, isSuccess]);

  return (
    <div className={`successDiv ${isSuccess ? "payment-success" : "payment-cancel"}`}>
      <div className="success-container">
        <div className="payment-result-card">
          <div className="payment-result-icon" aria-hidden="true">
            <FontAwesomeIcon icon={isSuccess ? faCheck : faXmark} />
          </div>
          <h1>{isSuccess ? "Payment successful" : "Payment cancelled"}</h1>
          <p>
            {isSuccess
              ? "Thank you. Your payment has been received and your order is being processed."
              : "Your payment was not completed. Your cart is still available if you would like to try again."}
          </p>
          <Link className="payment-result-link" to={isSuccess ? "/shop" : "/checkout"}>
            {isSuccess ? "Continue shopping" : "Return to checkout"}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaySuccess;
